import { render, staticRenderFns } from "./SignatureButton.vue?vue&type=template&id=62d20951"
import script from "./SignatureButton.vue?vue&type=script&lang=ts"
export * from "./SignatureButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports